import React from 'react';
import { useNavigate } from 'react-router-dom';
import FeaturedSolutions, { AgilysysLogo } from '../components/FeaturedSolutions';

const A = '/assets/casino/solutions/';

const solutions = [
  { name: 'IG Fly',        path: 'ig-fly',        screenshot: A + 'fly-tap-pay-tall.png' },
  { name: 'IG OnDemand',   path: 'ig-on-demand',  screenshot: A + 'app-ondemand-drinks.png' },
  { name: 'IG Quick Pay',  path: 'ig-quick-pay',  screenshot: A + 'app-qr-quickpay-tall.png' },
  { name: 'IG Smart Menu', path: 'ig-smart-menu', screenshot: A + 'app-order-menu.png' },
  { name: 'Reserve',       path: 'reserve',       screenshot: A + 'app-reserve-theatre.png' },
];

function Theatre() {
  const navigate = useNavigate();
  return (
    <div className="page splash theatrePage">
      <div className="background" />
      <div className="page-header">Theatre</div>
      <div className="text-blocks">
        <div className="std-text">
          Ensure your patrons don't miss a minute of the show with self-service ordering directly from their seat. Individual QR codes identify each seat when ordering, so the servers know exactly where to deliver their orders without any interruptions. Or enable servers to take orders and accept payment wherever the patron is with mobile all-in-one devices.
        </div>
      </div>
      <FeaturedSolutions>
        {solutions.map((sol) => (
          <div key={sol.path} className="featured-item" onClick={() => navigate(`/solutions/${sol.path}`)}>
            <div className="item-head"><AgilysysLogo />{sol.name}</div>
            <img src={sol.screenshot} alt={sol.name} />
          </div>
        ))}
      </FeaturedSolutions>
    </div>
  );
}

export default Theatre;
